import * as React from 'react';
import { useState } from "react";
import { AppBar, Toolbar, Typography, Grid, Avatar, Menu, MenuItem, Tooltip, } from "@mui/material"
import IconButton from '@mui/material/IconButton';
import LogoutIcon from '@mui/icons-material/Logout';
import { useTheme } from '@mui/material/styles';
import { logout } from '@carrier-sce-sharedpackages/auth-module';
import appConfig from "../config";
import { useEffect } from 'react';
import { fetchAPI } from '../utils/ApiService';

const drawerWidth = 300;
const collapsedWidth = 80;

export const Header = ({ isExpanded }) => {
    const [isSidebarExpanded, setIsSidebarExpanded] = useState(false);

    const headerStyle = {
        fontWeight: "700",
        fontSize: "26px",
        paddingLeft: '10px',
        transition: 'margin-left 0.3s',
        marginLeft: isSidebarExpanded ? `${drawerWidth}px` : `${collapsedWidth}px`,
        fontFamily: "DM Sans, sans-serif"
    }

    const toolbarStyle = {
        display: "flex",
        justifyContent: "space-between",
    }

    const avatarStyle = {
        width: 40,
        height: 40,
        fontSize: "1.5rem",
        marginRight: "10px",
        bgcolor: "#ce8600"
    }

    const gridStyle = {
        display: "flex",
        justifyContent: "end",
    }

    const theme = useTheme();
    const [user, setUser] = React.useState("User");
    const [anchorEl, setAnchorEl] = useState(null);

    useEffect(() => {
        setIsSidebarExpanded(isExpanded)
    }, [isExpanded])

    useEffect(() => {
        get_chiller_list();
    }, []);

    const get_chiller_list = async () => {
        const param = {};

        try {
            const token = localStorage.getItem("msal.idtoken");
            const headers = {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            };
            const userdata = await fetchAPI.post("/get_username", param, {
                headers
            });
            console.log("userdata", userdata);

            if (userdata && userdata.data) {
                setUser(userdata.data.username);
            }
        } catch (error) {
            console.error("Failed to fetch user data", error);
        }
    };

    const handleLogout = () => {
        localStorage.clear();
        logout(appConfig.api, true);
    }

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };


    return (
        <>
            <Grid container   >
                <AppBar sx={{ backgroundColor: '#0b03a6' }} elevation={0}>
                    <Toolbar sx={toolbarStyle}>

                        <Grid >
                            <Typography variant="h1" style={headerStyle}>
                                SC AI/ML CoE Surrogate Model Generation and Optimization
                            </Typography>
                        </Grid>

                        <Grid sx={gridStyle}>
                            <Tooltip title={user}>
                                <IconButton
                                edge="end"
                                aria-label="account of current user"
                                aria-controls="menu-appbar"
                                aria-haspopup="true"
                                onClick={handleClick}
                                color="inherit"
                            >
                                <Avatar sx={avatarStyle}>{user[0]}</Avatar>
                            </IconButton>

                            </Tooltip>
                            
                            {/* <Typography
                                sx={{
                                    fontSize: '1rem !important',
                                    color: 'common.white',
                                    fontWeight: 'bold !important',
                                    marginRight: theme.spacing(2)
                                }}
                            >
                                {user}
                            </Typography> */}
                            {/* <Menu
                                id="menu-appbar"
                                anchorEl={anchorEl}
                                anchorOrigin={{
                                    vertical: 'bottom',
                                    horizontal: 'center',
                                }}
                                keepMounted
                                open={Boolean(anchorEl)}
                                onClose={handleClose}
                            >
                                <MenuItem onClick={handleLogout}>Logout</MenuItem>
                            </Menu> */}
                            <Tooltip title="Logout">
                                <IconButton
                                    sx={{
                                        color: 'common.white',
                                        marginRight: theme.spacing(3),
                                        marginLeft: "10px"
                                    }}
                                    onClick={handleClick} // Define your logout function
                                >
                                    <LogoutIcon />
                                </IconButton>
                            </Tooltip>
                            <Menu
                                id="menu-appbar"
                                anchorEl={anchorEl}
                                anchorOrigin={{
                                    vertical: 'bottom',
                                    horizontal: 'center',
                                }}
                                keepMounted
                                open={Boolean(anchorEl)}
                                onClose={handleClose}
                            >
                                <MenuItem onClick={handleLogout}>Logout</MenuItem>
                            </Menu>

                        </Grid>

                    </Toolbar>
                </AppBar>
            </Grid>
        </>

    )
}